import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import APopover from "views/pages/manage/common/a-popover";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData, fetchAllPromisedData, updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { FILTER__FORM_FIELDS_GLOBAL, getDropdowns, getFilterReqObj } from "./constants";
import ListComponent from "./ListComponent";
import JsonDialog from "./components/JsonDialog";
import FilterForm from "./FilterForm";

const QrCodeMonitor = ({ userPermissions, type }) => {

    const history = useHistory();
    const ref = useRef();

    const [isloading, setIsLoading] = useState(false);
    const [dropdowns, setDropdowns] = useState([]);
    const [rows, setRows] = useState([]);
    const [jsonData, setJsonData] = useState({});
    const [filterForm, setFilterForm] = useState({ ...FILTER__FORM_FIELDS_GLOBAL });
    const [filterCount, setFilterCount] = useState(getFilterCount({ ...filterForm }, ["gstType"]));
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);
    const [viewJsonDialog, setViewJsonDialog] = useState(false);
    const invoiceType = type?.toUpperCase();


    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
    };

    const fetchList = async (reqObj = {}, pageNumber = 0, pageSize = currPageSize) => {
        try {
            setIsLoading(true);
            const resp = await fetchAllPostPromisedData(
                `${endpoint?.invoiceEngine?.qrCodeMonitor?.search}?offset=${pageNumber}&pageSize=${pageSize}`,
                { ...reqObj },
                "post"
            );

            if (resp?.code === 200) {
                setRows(resp?.data?.paginatedData);
                setCurrentPageSize(pageSize);
                setPaginationInfo({
                    currentPage: resp?.data?.currentPage,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords,
                });
                // ref.current.stopEditing();
            }

        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    }

    const retryHandler = async (invoiceId, businessArea) => {
        try {
            setIsLoading(true);
            const resp = await fetchAllPostPromisedData(
                `${endpoint?.invoiceEngine?.qrCodeMonitor?.retry}?invoiceId=${invoiceId}&businessArea=${businessArea}`,
                {},
                "post"
            );

            if (resp?.code === 200) {
                fetchList({ gstType: invoiceType })
            }

        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    }

    const applyFilterHandler = (filters = {}) => {
        const reqObj = getFilterReqObj(filters, invoiceType);
        fetchList(reqObj, 0, currPageSize);
    };

    const handleClose = () => {
        setViewJsonDialog(false);
    }

    const init = async () => {
        try {
            setIsLoading(true);
            const res = await getDropdowns();
            await fetchList({ gstType: invoiceType });
            setDropdowns(res);

        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (type) {
            init();
        }
    }, [type]);

    const nextButtonHandler = (newPage, currPageSize) => {
        const reqObj = getFilterReqObj(filterForm, invoiceType);
        fetchList(reqObj, newPage, currPageSize);
    };

    const viewJsonHandler = async (businessArea, invoiceId) => {
        try {
            setIsLoading(true);
            const resp = await fetchAllPromisedData(`${endpoint?.invoiceEngine?.qrCodeMonitor?.getJson}?invoiceId=${invoiceId}&businessArea=${businessArea}`, true);
            if (resp?.code === 200) {
                setJsonData(resp?.data);
                setViewJsonDialog(true);
            }

        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <Card className="mx-2">
                <div className="d-flex justify-content-between my-3 mx-2">
                    <div className="d-flex justify-content-between">
                        <BackArrow
                            className="color-black mr-2 cursor"
                            onClick={() => history.goBack()}
                        />
                        <h4>{type === "B2C" ? `${type} QR Code Monitor` : "E-Invoice B2B Monitor"}</h4>
                    </div>
                    <div className="d-flex justify-content-between">
                        <APopover
                            buttonComponent={(onClick, styles) => (
                                <AButton
                                    className="tiny-semi-bold color-dark"
                                    onClick={onClick}
                                    updatedStyle={{
                                        minWidth: "61px",
                                        ...(filterCount > 0
                                            ? {
                                                border: "1px solid #00B0F5",
                                                color: "#00B0F5",
                                            }
                                            : styles),
                                    }}
                                >
                                    Filters {filterCount > 0 && <>( {filterCount} )</>}
                                </AButton>
                            )}
                            menuComponent={(closePopup) => (
                                <FilterForm
                                    closePopup={closePopup}
                                    dropdownData={dropdowns}
                                    filterForm={filterForm}
                                    filterCount={filterCount}
                                    setFilterCount={setFilterCount}
                                    setFilterForm={setFilterForm}
                                    applyFilterHandler={applyFilterHandler}
                                    filterFormHandler={filterFormHandler}
                                />
                            )}
                        />
                    </div>
                </div>

                <ListComponent
                    rows={rows}
                    ref={ref}
                    isloading={isloading}
                    setIsLoading={setIsLoading}
                    nextButtonHandler={nextButtonHandler}
                    dropdowns={dropdowns}
                    rowCount={paginationInfo.totalRecords}
                    currentPage={paginationInfo?.currentPage}
                    currPageSize={currPageSize}
                    viewJsonHandler={viewJsonHandler}
                    retryHandler={retryHandler}
                />
            </Card>

            <JsonDialog
                handleClose={handleClose}
                isOpen={viewJsonDialog}
                jsonData={jsonData}
            />
        </>
    )
}

export default QrCodeMonitor;